import emitter from "tiny-emitter/instance";
import { isFunction } from "lodash";
var EVENT = "PB_MFA_REQUIRED";
var MFA = /** @class */ (function () {
    function MFA() {
        this._show = false;
    }
    Object.defineProperty(MFA.prototype, "show", {
        get: function () {
            return this._show;
        },
        set: function (value) {
            var emit = this._show !== value;
            this._show = value;
            if (emit)
                emitter.emit(EVENT);
        },
        enumerable: true,
        configurable: true
    });
    MFA.prototype.start = function (complete, cancel) {
        this.show = true;
        this._complete = complete;
        this._cancel = cancel;
    };
    MFA.prototype.complete = function () {
        this.show = false;
        if (isFunction(this._complete)) {
            this._complete();
        }
    };
    MFA.prototype.cancel = function () {
        this.show = false;
        if (isFunction(this._cancel)) {
            this._cancel();
        }
    };
    MFA.prototype.addEventListener = function (cb) {
        emitter.on(EVENT, cb);
    };
    MFA.prototype.removeEventListener = function (cb) {
        emitter.off(EVENT, cb);
    };
    return MFA;
}());
export default new MFA();
